export interface ValidationResult {
    isValid: boolean;
    error?: string;
}

export function validateDateRange(dateFrom: string, dateTo: string): ValidationResult {
    if (dateFrom > dateTo) {
        return { isValid: false, error: 'Start date must be before or equal to end date' };
    }
    return { isValid: true };
}

/**
 * Validates a UUID string.
 * @param id The UUID string to validate.
 * @throws {Error} If the UUID string is invalid.
 */
export function validateUUID(id: string) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(id)) {
        throw new Error('Invalid ID format');
    }
}
